/**
 * Get all the details from Airtable
 * @param {string} url URL for the particular Airtable Base
 * @param {string} apiKey API Key to access the particular Airtable Base
 * @param {string} searchString Optional Search string to get details based on Search text
 * @returns {Array} List of all the data from airtable or searched response if there is a search text
 */
export async function getAllDataFromAirtable(url, apiKey, searchString) {
  let param = '';
  let finalResponse = [];
  let project = 'recAODYUWYKPF7GMa';
  if (searchString) {
    //param = `?filterByFormula=AND(FIND(%22${project}%22%2C%20%7Bprojects%7D%20%26%20%27%27)%2C(LOWER(%7Btitle%7D)%3DLOWER("${searchString.trim()}")))`;
    //param = `?filterByFormula=(AND(FIND(%22${project}%22%2C+%7Bprojects%7D+%26+'')%2COR(SEARCH("${searchString.trim()}"%2C+%7Btitle%7D)%2CSEARCH("${searchString.trim()}"%2C+%7Bdescription%7D))))`
    param = `?filterByFormula=(AND(FIND(%22${project}%22%2C+%7Bprojects%7D+%26+'')%2COR(SEARCH(LOWER("${searchString.trim()}")%2C+LOWER(%7Btitle%7D))%2CSEARCH(LOWER("${searchString.trim()}")%2C+LOWER(%7Bdescription%7D)))))`
  } else {
    param = `?filterByFormula=(FIND%28%22${project}%22%2C%20%7Bprojects%7D%20%26%20%27%27%29)`;
  }
  await fetch(`${url}${param}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${apiKey}`,
    },
  })
    .then((response) => response.json())
    .then((response) => {
      // Format the data that is coming from airtable and change it to be an array of items
      response.records.map((item) => finalResponse.push(item?.fields));
    })
    .catch((error) => console.error(error));
  return finalResponse;
}

/**
 * Get Individual item from Airtable by passing the ID of the particular Item
 * @param {string} url URL for the particular Airtable Base
 * @param {string} apiKey API Key used to access the particular Airtable Base
 * @param {string} itemId ID for the particular item
 * @returns {Array} Details of the particular Item with the ID
 */
export async function getIndividialDataFromAirtable(url, apiKey, itemId) {
  let airtableResponse;
  await fetch(`${url}/${itemId}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${apiKey}`,
    },
  })
    .then((response) => response.json())
    .then((response) => (airtableResponse = response?.fields))
    .catch((error) => console.error(error));
  // Get the data from airtable and return the fields from the response of that particular item
  return airtableResponse;
}
